<template>
    <b-row class="mt-2">
        <b-col cols="12">
            <b-nav tabs align="center">
                <b-nav-item :to="{ name: 'UltimeMassime' }" active-class="active">
                    <font-awesome-icon icon="home" />
                    Le ultime massime
                </b-nav-item>
                <b-nav-item :to="{ name: 'RicercaMassime' }" active-class="active">                
                    <font-awesome-icon icon="search" />
                    Ricerca tra le massime
                </b-nav-item>
                <b-nav-item :to="{ name: 'NewsletterMassime' }" active-class="active">
                    <font-awesome-icon icon="envelope" />
                    Iscriviti alla newsletter
                </b-nav-item>
            </b-nav>
        </b-col>
    </b-row>
</template>

<script>
export default {
    data () {
        return {
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Pubblica/Menu.vue